module.exports = __webpack_public_path__ + "img/nostalgia-carpet.06d8d468.jpeg";